const stringifySearchParams = (
  searchParams: Record<string, string | string[] | undefined>,
): string => {
  return Object.entries(searchParams)
    .map(([key, val]) => {
      if (val) {
        if (Array.isArray(val)) {
          return val
            .map((_val) => `${key}[]=${encodeURIComponent(_val)}`)
            .join('&');
        } else {
          return `${key}=${encodeURIComponent(val)}`;
        }
      }
      return '';
    })
    .filter((queryParam) => !!queryParam)
    .join('&');
};

export default stringifySearchParams;
